import Vue from 'vue'

// Simple observable store with a queue and history
export const notifyStore = Vue.observable({
  queue: [],
  current: null,
  visible: false,
  history: [],
  unreadCount: 0
})

const typeToColor = {
  success: 'green darken-1',
  error: 'red darken-2',
  info: 'blue darken-1',
  warning: 'orange darken-2'
}

function uid () {
  return `${Date.now()}_${Math.random().toString(36).slice(2)}`
}

function showNext () {
  if (notifyStore.visible) return
  if (notifyStore.queue.length === 0) return
  notifyStore.current = notifyStore.queue.shift()
  notifyStore.visible = true
}

export function closeNotify () {
  notifyStore.visible = false
  notifyStore.current = null
  // next in microtask
  Promise.resolve().then(showNext)
}

function addToHistory (entry) {
  notifyStore.history.unshift(entry)
  notifyStore.unreadCount += 1
}

export function markAllRead () {
  notifyStore.unreadCount = 0
  notifyStore.history = notifyStore.history.map(n => ({ ...n, read: true }))
}

export function clearAllNotifications () {
  notifyStore.history = []
  notifyStore.unreadCount = 0
}

export function removeNotificationById (id) {
  notifyStore.history = notifyStore.history.filter(n => n.id !== id)
}

export function notify (messageOrOptions, type = 'info') {
  const isString = typeof messageOrOptions === 'string'
  const base = isString ? { text: messageOrOptions, type } : { ...messageOrOptions }
  const normalized = {
    id: uid(),
    text: base.text || base.message || '',
    type: base.type || type,
    color: base.color || typeToColor[base.type] || typeToColor[type] || typeToColor.info,
    date: new Date(),
    read: false
  }
  // enqueue for snackbar
  notifyStore.queue.push({ text: normalized.text, color: normalized.color })
  showNext()
  // add to history
  addToHistory(normalized)
}

export default {
  install (VueInstance) {
    VueInstance.prototype.$notify = notify
    VueInstance.prototype.$notifyClose = closeNotify
    VueInstance.prototype.$notifyStore = notifyStore
    VueInstance.prototype.$notifyMarkAllRead = markAllRead
    VueInstance.prototype.$notifyClearAll = clearAllNotifications
    VueInstance.prototype.$notifyRemoveById = removeNotificationById
  }
}


